import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function LatestArticles() {
  const latestArticles = articles
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(0, 6);

  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              最新文章
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              持续更新的51cg黑料深度报道
            </p>
          </div>
          <Link
            to="/category/zuixin-baoliao"
            className="hidden sm:flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-5">
          {latestArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex flex-col sm:flex-row gap-5 p-5 rounded-xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className="flex-shrink-0 w-full sm:w-48 h-32 overflow-hidden rounded-lg">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2 flex-wrap">
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded-md font-medium">
                    {index === 0 ? "最新发布" : article.category === "zuixin-baoliao" ? "最新爆料" : "深度报道"}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views.toLocaleString()}
                  </span>
                  <span>{article.readTime}</span>
                  <span>{article.publishedAt}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors font-heading leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}